import { render } from "./TrfModalAlterarData.vue?vue&type=template&id=d609d72c&scoped=true"
import script from "./TrfModalAlterarData.vue?vue&type=script&lang=js"
export * from "./TrfModalAlterarData.vue?vue&type=script&lang=js"

import "./TrfModalAlterarData.vue?vue&type=style&index=0&id=d609d72c&lang=scss&scoped=true"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d609d72c"],['__file',"src/components/Modal/TrfModalAlterarData.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d609d72c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d609d72c', __exports__)) {
    console.log('reload')
    api.reload('d609d72c', __exports__)
  }
  
  module.hot.accept("./TrfModalAlterarData.vue?vue&type=template&id=d609d72c&scoped=true", () => {
    console.log('re-render')
    api.rerender('d609d72c', render)
  })

}


export default __exports__